import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=0080c368&scoped=true&"
import script from "./pool.vue?vue&type=script&lang=js&"
export * from "./pool.vue?vue&type=script&lang=js&"
import style0 from "./pool.vue?vue&type=style&index=0&id=0080c368&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080c368",
  null
  
)

export default component.exports